function AmPmConverter(time24) {
    var ts = time24;
    var H = +ts.substr(0, 2);
    var h = (H % 12) || 12;
    h = (h < 10) ? ("0" + h) : h;  // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
};

const defaultDateFormatWithTime = (ISODate) => {
    return `${new Date(ISODate).getDate()}/${new Date(ISODate).getMonth() + 1}/${new Date(ISODate).getFullYear()} ${AmPmConverter(`${new Date(ISODate).getHours() > 9 ? new Date(ISODate).getHours() : "0"+new Date(ISODate).getHours() }:${new Date(ISODate).getMinutes() > 9 ? new Date(ISODate).getMinutes() : "0" + new Date(ISODate).getMinutes()}:${new Date(ISODate).getMilliseconds()}`)}`
}

const defaultDateFormatFromISO = (ISODate)=>{
    return `${new Date(ISODate).getDate()}/${new Date(ISODate).getMonth() + 1}/${new Date(ISODate).getFullYear()}`
}

export {
    AmPmConverter,
    defaultDateFormatWithTime,
    defaultDateFormatFromISO
}
